import AnnouncementsIndex from '@/views/AnnouncementsIndex.vue';
import AnnouncementsCreate from '@/views/AnnouncementsCreate.vue';
import AnnouncementsEdit from '@/views/AnnouncementsEdit.vue';

const routes = [
    {
        path: '/announcements',
        name: 'AnnouncementsIndex',
        component: AnnouncementsIndex,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/announcements/create',
        name: 'AnnouncementsCreate',
        component: AnnouncementsCreate,
        meta: { layout: 'DashboardLayout' }
    },
    {
        path: '/announcements/:id',
        name: 'AnnouncementsEdit',
        component: AnnouncementsEdit,
        meta: { layout: 'DashboardLayout' }
    }
];

export default routes
